// ============================================================================
// NavbarProvider — the state behind NavbarContext
// ============================================================================
// Split out of NavbarContext.tsx so that file exports no component: mixing a
// component with the hook and types broke Fast Refresh for all 28 of its
// importers. This file exports exactly one component.

import { useState, useCallback } from 'react'
import type { ReactNode } from 'react'
import { NavbarContext, defaultState } from './NavbarContext'
import type { NavbarState } from './NavbarContext'

export function NavbarProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<NavbarState>(defaultState)

  const setNavbar = useCallback((s: Partial<NavbarState>) => setState((prev) => ({ ...prev, ...s })), [])
  const resetNavbar = useCallback(() => setState(defaultState), [])

  return (
    <NavbarContext.Provider value={{ ...state, setNavbar, resetNavbar }}>
      {children}
    </NavbarContext.Provider>
  )
}
